import {Component, OnInit} from '@angular/core';
import {AbcComplettApiService} from '../../services/abc-complett-api/abc-complett-api.service';
import {SuchTreffer} from '../../models/Suche';
import {MatDialog} from '@angular/material/dialog';
import {Laden} from '../../models/Laden';
import {LadenDialogComponent} from '../ui/dialog/laden-dialog/laden-dialog.component';
import {CookieStorageService} from '../../services/cookie-storage/cookie-storage.service';
import {EventEmitterService} from '../../services/event-emitter/event-emitter.service';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints, BreakpointState} from '@angular/cdk/layout';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  searchString: string;
  searching = false;
  searchResult: SuchTreffer;

  private get cookiesAgreed(): boolean {
    return this.cookieStorage.hasAgreed;
  }

  private searchTimer;
  private persistSearchTimer;
  private handsetChange: Observable<BreakpointState>;
  private tabletChange: Observable<BreakpointState>;
  private webChange: Observable<BreakpointState>;
  private landscapeChange: Observable<BreakpointState>;
  private portraitChange: Observable<BreakpointState>;
  private isLandscape = false;
  private isHandset = false;

  constructor(
    private apiService: AbcComplettApiService,
    public dialog: MatDialog,
    private cookieStorage: CookieStorageService,
    private eventEmitterService: EventEmitterService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.handsetChange = breakpointObserver.observe([
      Breakpoints.Handset
    ]);
    this.tabletChange = breakpointObserver.observe([
      Breakpoints.Tablet
    ]);
    this.webChange = breakpointObserver.observe([
      Breakpoints.Web
    ]);
    this.landscapeChange = breakpointObserver.observe([
      Breakpoints.HandsetLandscape
    ]);
    this.portraitChange = breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ]);
  }

  ngOnInit() {
    this.portraitChange.subscribe(result => {
      if (result.matches) {
        this.isLandscape = false;
      }
    });
    this.landscapeChange.subscribe(result => {
      if (result.matches) {
        this.isLandscape = true;
      }
    });
    this.handsetChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = true;
      }
    });
    this.tabletChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = false;
      }
    });
    this.webChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = false;
      }
    });
  }

  startSearchTimer(event: KeyboardEvent) {
    if (event.key !== 'ArrowRight'
      && event.key !== 'ArrowLeft'
      && event.key !== 'ArrowUp'
      && event.key !== 'ArrowDown'
      && event.key !== 'PageUp'
      && event.key !== 'PageDown'
      && event.key !== 'Home'
      && event.key !== 'End'
    ) {
      this.searching = false;
      this.searchResult = undefined;
      clearTimeout(this.searchTimer);
      clearTimeout(this.persistSearchTimer);
      const query = this.searchString.replace(' ', ',');
      if (query.length > 0) {
        this.searchTimer = setTimeout(() => {
          this.searching = true;
          this.apiService.performSearch(query).subscribe(result => {
            this.searching = false;
            this.searchResult = result;
            const count = result.count;
            this.persistSearchTimer = setTimeout(() => {
              this.apiService.persistSearchLog(query, count).subscribe();
            }, 2000);
          });
        }, 500);
      }
    }
  }

  openOverlay(branchenId: number) {
    const laden: Laden = {
      branchenId
    };
    this.dialog.open(LadenDialogComponent, {
      data: {
        laden
      },
      autoFocus: false
    });
  }

  searchGotFocus(event: any, showHeader: boolean) {
    if (!this.cookiesAgreed) {
      this.eventEmitterService.emitCookiePopup();
    }
    if (this.isHandset && this.isLandscape) {
      this.eventEmitterService.emitDisplayHeader(showHeader);
      if (!showHeader) {
        event.target.parentElement.scrollIntoView({behavior: 'smooth'});
      }
    }
  }
}
